import React, { useMemo } from 'react';
import { Text } from '@ui-kitten/components';
import mergeStyles from "../../util/mergeStyles";
export var DNACategoriesEnum;
(function (DNACategoriesEnum) {
    DNACategoriesEnum["h1"] = "h1";
    DNACategoriesEnum["h2"] = "h2";
    DNACategoriesEnum["h3"] = "h3";
    DNACategoriesEnum["h4"] = "h4";
    DNACategoriesEnum["h5"] = "h5";
    DNACategoriesEnum["b1"] = "p1";
    DNACategoriesEnum["b2"] = "p2";
    DNACategoriesEnum["c1"] = "c1";
    DNACategoriesEnum["c2"] = "c2";
    DNACategoriesEnum["c3"] = "c3";
    DNACategoriesEnum["p1"] = "p1";
    DNACategoriesEnum["p2"] = "p2";
    DNACategoriesEnum["label"] = "s1";
    DNACategoriesEnum["caption"] = "s2";
})(DNACategoriesEnum || (DNACategoriesEnum = {}));
export const DNACategoriesKeys = Object.keys(DNACategoriesEnum);
const S = {
    bold: {
        fontWeight: 700,
    },
    regularFontWeight: {
        fontWeight: 500,
    },
};
/**
 * This component allows us to quickly align any text we are placing in the app with our globally defined text theme via various properties.
 *
 * @property numberOfLines - Setting this will enable the truncation of text based on available space.
 *
 * For this feature to operate properly, at least one `DNABox` element with either a `fill` or `width` property defined needs to wrap the `DNAText` component.
 * Note, however, that when used in conjunction with multiple `DNABox` layers, the following parameters must be adhered to:
 *  - The top level `DNABox` needs to either have the `fill` property or `width` style property defined
 *  - The `spacing` property must not be enabled on the top level or intermediate `DNABox` elements
 *
 * @example
 * <DNABox style={{ width: 200}}>
 *  <DNABox fill>
 *   <DNAText h1 status="danger" numberOfLines={1}>
 *    Some dangerous text here
 *   </DNAText>
 *  </DNABox>
 * </DNABox>
 * */
export const DNAText = (props) => {
    const { children, h1, h2, h3, h4, h5, b1, b2, c1, c2, c3, p1, p2, label, caption, bold, ...rest } = props;
    const category = useMemo(() => {
        const [foundCategoryProp] = Object
            .entries(props)
            .find(([key, value]) => value && DNACategoriesEnum[key]) ??
            [];
        return foundCategoryProp
            ? { category: DNACategoriesEnum[foundCategoryProp] }
            : {};
    }, [h1, h2, h3, h4, h5, b1, b2, c1, c2, c3, p1, p2, label, caption]);
    return (<Text {...rest} {...category} style={mergeStyles(rest, [S.bold, bold], [S.regularFontWeight, bold === false])}>
      {children}
    </Text>);
};
export default DNAText;
//# sourceMappingURL=DNAText.js.map